// src/features/videos/VideoChips.tsx — chip row that genuinely filters
// (filterVideos.ts). Thin wrapper around the shared FilterChips (slice-4-xl S4
// — this used to be identical to Live's LiveChips apart from the generic type).
import { FilterChips } from '@/components/FilterChips/FilterChips';
import type { ChipDef } from './meta';
import type { VideoChipId } from '@/core/models/video';

export interface VideoChipsProps {
  chips: ChipDef[];
  active: VideoChipId;
  onChange: (id: VideoChipId) => void;
}

export function VideoChips({ chips, active, onChange }: VideoChipsProps) {
  return <FilterChips chips={chips} active={active} onChange={onChange} ariaLabel="Video filters" />;
}
